// extracted by mini-css-extract-plugin
export default {"breadcrumb":"Breadcrumb-module__breadcrumb__aab14ba3b17c5b3f2899"};